import React from 'react'
import { TouchableOpacity, Platform } from 'react-native'
import { Text } from 'native-base'

export default ({ navigation, text = 'Cancel' }) => (
  <TouchableOpacity onPress={() => navigation.goBack(null)}>
    <Text style={{ paddingLeft: 10 }}>{text}</Text>
  </TouchableOpacity>
)
